var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_28756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4792 2.02488H1.52071C1.41913 2.02488 1.32171 1.98435 1.24988 1.91222C1.17805 1.84008 1.1377 1.74223 1.1377 1.64021C1.1377 1.53819 1.17805 1.44035 1.24988 1.36821C1.32171 1.29607 1.41913 1.25555 1.52071 1.25555H11.4792C11.5808 1.25555 11.6782 1.29607 11.75 1.36821C11.8218 1.44035 11.8622 1.53819 11.8622 1.64021C11.8622 1.74223 11.8218 1.84008 11.75 1.91222C11.6782 1.98435 11.5808 2.02488 11.4792 2.02488Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87936 6.32924H3.12069C3.03921 6.32924 2.96107 6.28687 2.90346 6.21145C2.84584 6.13603 2.81348 6.03373 2.81348 5.92707C2.81348 5.82041 2.84584 5.71812 2.90346 5.6427C2.96107 5.56727 3.03921 5.5249 3.12069 5.5249H9.87936C9.96083 5.5249 10.039 5.56727 10.0966 5.6427C10.1542 5.71812 10.1866 5.82041 10.1866 5.92707C10.1866 6.03373 10.1542 6.13603 10.0966 6.21145C10.039 6.28687 9.96083 6.32924 9.87936 6.32924Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96518 10.6336H5.03271C4.97715 10.6336 4.92387 10.5912 4.88459 10.5158C4.84531 10.4404 4.82324 10.3381 4.82324 10.2314C4.82324 10.1248 4.84531 10.0225 4.88459 9.94705C4.92387 9.87163 4.97715 9.82925 5.03271 9.82925H7.96518C8.02074 9.82925 8.07402 9.87163 8.1133 9.94705C8.15258 10.0225 8.17465 10.1248 8.17465 10.2314C8.17465 10.3381 8.15258 10.4404 8.1133 10.5158C8.07402 10.5912 8.02074 10.6336 7.96518 10.6336Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_28756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 11,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.d993d5d67a75725f47877b680284d85f.svg";
export { ForwardRef as ReactComponent };